<template>
  <v-app>
    <div v-if="current_user.is_admin">
      <v-toolbar dark dense flat class="page_toolbar admin_menu_toolbar">
        <v-toolbar-title>
          <v-icon left small>fa-cogs</v-icon>Admin
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn small text to="/app/admin/clinics">
            <v-icon left>business</v-icon>Clinics
          </v-btn>
          <v-btn small text to="/app/admin/revisions">
            <v-icon left>fa-database</v-icon>Revisions
          </v-btn>
          <v-btn small text to="/app/admin/users">
            <v-icon left>account_circle</v-icon>Users
          </v-btn>
          <v-btn small text to="/app/admin/charges">
            <v-icon left>attach_money</v-icon>Charges
          </v-btn>
          <v-btn small text href="/api/assessment/49a09432-dc1d-41a0-ba3c-22b9cab94b5b/summary/report.csv">
            <v-icon left>assessment</v-icon>VA CSV
          </v-btn>
          <v-btn small text href="/api/assessment/1fa92ee2-aec9-4330-9100-024bd8e0bf73/summary/report.csv">
            <v-icon left>assessment</v-icon>ASCI CSV
          </v-btn>
          <v-btn small text to="/app/admin/emails">
            <v-icon left>email</v-icon>Emails
          </v-btn>
          <v-btn small text to="/app/admin/misc">
            <v-icon left>build</v-icon>Misc
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <AdminMisc />
    </div>
    <PermissionDenied v-else />
  </v-app>
</template>

<script>
import AdminMisc from "../../shared/components/admin/AdminMisc";
import PermissionDenied from "../../shared/components/PermissionDenied";

export default {
  name: "App",
  components: {
    AdminMisc,
    PermissionDenied,
  },
  data() {
    return {
      current_user: this.$root.$children[0].current_user,
    };
  },
};
</script>
